// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1x8a0","consentsList":"PatientConsents_consentsList__TZN8k","consentsListEmpty":"PatientConsents_consentsListEmpty__21F9s"};